import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
// TODO: fix sibling import
import { catalogLayoutSlice } from 'src/features/catalog';

export const useCloseCatalogItem = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    dispatch(catalogLayoutSlice.actions.setActiveItem(undefined));
  }, [dispatch]);
};
